import { Button, Text } from '@chakra-ui/react';
import { t } from 'i18next';
import { Link } from '~components/ui/Link';
import { Page } from '~components/ui/Page';
import { PageContent } from '~components/ui/PageContent';

export function PowerScheduleNotFoundPage() {
  return (
    <Page title="404" pageName="power_schedule_404" analyticsDisableTracking={true}>
      <PageContent maxWidth="300px" textAlign="center">
        <Text fontWeight="semibold" color="gray.600">
          {t('unauthorisedPowerScheduleErr')}
        </Text>

        <Text marginTop="8" fontSize="sm">
          {t('unauthorisedPowerScheduleErrMsg')}{' '}
          <Button as={Link} variant="link" size="sm" colorScheme="blue" to="../">
            {t('unauthorisedPowerScheduleErrMsg1')}
          </Button>
        </Text>
      </PageContent>
    </Page>
  );
}
